import React from 'react';
const SuccessIcon = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8.8 15.8998L4.6 11.6998L3.2 13.0998L8.8 18.6998L20.8 6.6998L19.4 5.2998L8.8 15.8998Z", fill: "#70BF73" })));
};
export default SuccessIcon;
